import { connect } from 'react-redux';

import { closeModal } from 'actions/modal';
import { MODAL_LEAVE_GROUP } from 'types/modal';
import { getCurrentUserIdSelector } from 'selectors/user';
import  { actions } from '@amplement/backend-connector';
import { push } from 'redux-first-history';
import { getUrl } from 'utils/url';

import Component from './index';

const mapStateToProps = state => ({
    ...state.modal[MODAL_LEAVE_GROUP],
    _me: getCurrentUserIdSelector(state)
});

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeModal(MODAL_LEAVE_GROUP)),
    onSubmit: (_feed, _user) => {
        dispatch(actions.members.kickMemberFromFeed(_feed, _user));
        dispatch(push(getUrl('dashboard')));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
